<template>
  <div class="c03-wrap">
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{
              this.$moment(this.startDate).format("YYYY-MM-DD")
            }}</span>
            <span v-if="$parent.endTimeShow"
              >至{{
                this.$moment(this.endDate).format("YYYY-MM-DD")
              }}</span
            >
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="c03-container">
        <div class="formTitle">
          <span class="zhanghao" style="width: 150px">账号</span>
          <span class="xingming">宾客姓名</span>
          <span class="fanghao">房号</span>
          <span class="fangxing">类型</span>
          <span class="fangjia" style="text-align: right">预授金额</span>
          <span class="fanghao">会员号</span>
          <span class="xingming" style="width: 120px">酒店日期</span>

          <span class="shijian3">操作员</span>
          <span class="xingming" style="width: 200px">操作时间</span>
          <span class="xingming">支付状态</span>
          <span style="text-align: left; padding-left: 10px; width: 120px"
            >备注</span
          >
        </div>
        <div v-for="item in list" class="PreArrivalItem">
          <div class="zhanghao" style="width: 150px">{{ item.accNo }}</div>
          <div class="xingming">{{ item.guestName }}</div>
          <div class="fanghao">{{ item.roomNo }}</div>
          <div class="fangxing">{{ item.chnName }}</div>
          <div class="fangjia" style="text-align: right">
            {{ curreny(item.amount) }}
          </div>
          <div class="fanghao">{{ item.memberNo }}</div>
          <div class="xingming" style="width: 120px">{{ item.hotelTime }}</div>

          <div class="shijian3">{{ item.operator }}</div>
          <div class="xingming" style="width: 200px">{{ item.updateTime }}</div>
          <div class="xingming">
            <span v-if="item.STATUS == 0">支付成功</span>
            <span v-if="item.STATUS == 1">撤销 </span>
            <span v-if="item.STATUS == 2">已使用</span>
            <span v-if="item.STATUS == 3">撤销失败</span>
            <span v-if="item.STATUS == 4">使用失败</span>
          </div>
          <div style="text-align: left; padding-left: 10px; width: 120px">
            {{ item.remark }}
          </div>
        </div>
        <!-- <div class="formTitle" style="border: none; font-weight: bold">
          <span class="zhanghao"></span>
          <span class="xingming"></span>
          <span class="fanghao"></span>
          <span class="fangxing">合计</span>
          <span class="fangjia" style="text-align: right">{{ total }}</span>
          <span class="fanghao"></span>
          <span class="shijian3"></span>
          <span class="xingming"></span>
          <span style="flex: 1"></span>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      list: [],
      total: 0,
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.closeshow();
    this.$parent.bbmc = "C21.前台宾客预授权报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.startTimeShow = true;
    this.$parent.endTimeShow = true;
    this.$parent.chaxunvib = true;
    this.$parent.showPay = true;
    this.getData();
  },
  methods: {
    curreny(data) {
      if (data == 0) {
        return "0.00";
      } else if (data) {
        data = Number(data).toFixed(2);
        return data;
      }
    },
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      this.getData();
    },
    getData() {
      let that = this;
      let postparm = {
        startDate: this.$parent.startDate,
        endDate: this.$parent.endDate,
      };
      if (this.$parent.banci > 0) {
        postparm.shift = this.$parent.banci;
      }
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("/tSysReport2/selectC21", postparm).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        // return;
        if (res.status == 200) {
          // res.data.list.forEach((timeItem) => {
          //   timeItem.createTime = this.$moment(timeItem.createTime).format(
          //     "YYYY-MM-DD "
          //   );
          // });
          let list1 = [];
          res.data.forEach((item) => {
            if (this.$parent.Pay != null) {
              if (item.STATUS == this.$parent.Pay) {
                list1.push(item);
              }
            } else {
              list1 = res.data;
            }
          });
          this.list = list1;
          this.total = res.data.allAmount;
          this.$store.state.preArrivalList = this.list;
          this.list.forEach((item) => {
            if (item.STATUS == 1) {
              item.style = "撤销";
            }
            if (item.STATUS == 2) {
              item.style = "已使用";
            }
            if (item.STATUS == 3) {
              item.style = "撤销失败";
            }
            if (item.STATUS == 4) {
              item.style = "使用失败";
            }
          });
          this.$store.state.preArrivalName = "C21.前台宾客预授权报表";
          that.$parent.datacount = res.data.length;
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.c03-wrap {
  width: 100%;
  padding: 20px;
}
.c03-head > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.c03-head > div div {
  flex: 1;
  line-height: 22px;
  font-size: 14px;
}
.c03-head > div div:nth-child(2) {
  text-align: center;
}
.c03-head > div div:nth-child(3) {
  text-align: right;
}

.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
</style>